import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EmpSuccess from "../employees/employeeSuccess";
import "../employees/index.css";
import {
  createNewDiscount,
  getAllDiscounts,
  updateDiscountById,
} from "../../../apis/discount";
import moment, { Moment } from "moment";
import { successAlert } from "../../../style/scss/utils/Alerts";
import Newloader from "../employees/loader";
import { formatDate } from "../../../environment";
import * as XLSX from "xlsx";


const DiscountsList = () => {
  const initialValues = {
    name: "",
    amount: "",
    percentage: "",
    start_date: "",
    end_date: "",
    coupon_code: "",
  };

  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;

  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const { name, amount, percentage, end_date, start_date, coupon_code } =
    formData;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  type EmployeeResponse = {
    discount_name: string;
    Image: string;
    CurrentRole: string;
    amount: string;
    percentage: string;
    coupon_code: string;
    start_date: string;
    end_date: string;
    id: any;
    status: string;
    createdAt: string;
  };

  type EmployeeData = {
    key: number;
    coupon_code: string;
    Name: string;
    id: any;
    Phone: string;
    percentage: string;
    start_date: string;
    end_date: string;
    amount: string;
    Status: string;
    createdAt: string;
  };
  const [loader, setLoader] = useState(false);
  const fetchAllEmployees = async () => {
    setLoader(true);
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
      };
      const response = await getAllDiscounts(data);
      const newEmployeeData = response?.data?.filter(
        (item: any) => item.isVoucher !== true
      );
      const employeeData = newEmployeeData?.map(
        (item: EmployeeResponse, i: number) => ({
          key: `${i + 1}`,
          id: item.id,
          createdAt: formatDate(item.createdAt),
          Name: `${item.discount_name}`,
          amount: item.amount ? `${item.amount}` : "0",
          start_date: item.start_date || "--",
          end_date: item.end_date || "--",
          coupon_code: item.coupon_code,
          percentage: item.percentage ? `${item.percentage}%` : "0",
          Status: item.status,
        })
      );
      setEmployeeData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false);
    }
  };
  const [newStatus, setNewStatus] = useState<any>(null);
  const handleChangeStatus = (data: { id: string; status: string }) => {
    const payload = {
      id: data.id,
      status: data.status,
    };
    setNewStatus(payload);
  };
  const handleSubmitStatus = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    try {
      const payload = {
        status: newStatus?.status,
      };
      const response = await updateDiscountById(newStatus?.id, payload);
      if (response.status === true) {
        successAlert("success", `Status Changed to ${newStatus?.status}`);
        fetchAllEmployees();
        setNewStatus(null);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };
  useEffect(() => {
    fetchAllEmployees();
  }, [state]);

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allEmployeeData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Discounts");
    XLSX.writeFile(workbook, "Discount List.xlsx");
  };

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "key",
      render: (_: any, record: EmployeeData) => <div>{record.key}</div>,
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (_: any, record: EmployeeData) => <div>{record.createdAt}</div>,
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div>{record.Name}</div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Discount Amt.",
      dataIndex: "amount",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div>{record.amount}</div>
        </div>
      ),
    },
    {
      title: "Discount %",
      dataIndex: "percentage",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div>{record.percentage}</div>
        </div>
      ),
    },
    {
      title: "Coupon Code",
      dataIndex: "coupon_code",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div>{record.coupon_code}</div>
        </div>
      ),
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div>{record.start_date}</div>
        </div>
      ),
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div>{record.end_date}</div>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: EmployeeData) => (
        <span className="dropdown">
          <Link
            to="#"
            className={`badge  btn btn-white ${text === "Active" ? "badge-success" : "badge-danger"
              } d-inline-flex align-items-center badge-xs`}
            data-bs-toggle="dropdown"
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </Link>
          <ul className="dropdown-menu dropdown-menu-end p-3">
            <li>
              <div
                data-bs-toggle="modal"
                data-bs-target="#status_mo"
                className="dropdown-item rounded-1"
                onClick={() =>
                  handleChangeStatus({ id: record.id, status: "Active" })
                }
              >
                Active
              </div>
            </li>
            <li>
              <div
                data-bs-toggle="modal"
                data-bs-target="#status_mo"
                className="dropdown-item rounded-1"
                onClick={() =>
                  handleChangeStatus({ id: record.id, status: "InActive" })
                }
              >
                InActive
              </div>
            </li>
          </ul>
        </span>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Status.localeCompare(b.Status),
    },
    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   render: (text: string, record: EmployeeData) => (
    //     <div className="action-icon d-inline-flex">
    //       <Link
    //         to="#"
    //         className="me-2"
    //         data-bs-toggle="modal"
    //         data-bs-target="#add_employee"
    //       >
    //         <i className="ti ti-edit" />
    //       </Link>
    //     </div>
    //   ),
    // },
  ];

  const handleSubmit = async (event: any) => {
    setLoader(true);
    event.preventDefault();
    const payload = {
      status: "Active",
      discount_name: formData.name,
      coupon_code: formData.coupon_code,
      amount: !percentage ? formData.amount : "0",
      start_date: formData.start_date,
      end_date: formData.end_date,
      percentage: !amount ? formData.percentage : "0",
      isVoucher: false,
    };
    try {
      const response = await createNewDiscount(payload);
      if (response.status === true) {
        successAlert("success", "Discount created successfully");
        setFormData(initialValues);
        setSuccessCreation(true);
        fetchAllEmployees();
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>

              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_employee"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Create New
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div>
                    <label style={{ color: "#000" }}>Search</label>
                    <input
                      type="text"
                      className="form-control form-control-sm me-2"
                      placeholder="Enter a search term"
                      style={{
                        backgroundColor: "#b4b4b447",
                        padding: "0.2rem 0.85rem",
                        marginTop: "5px",
                      }}
                    />
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {/* <li>
                                        <div
                                          onClick={exportToPDF}
                                          className="btn  dropdown-item rounded-1"
                                        >
                                          <i className="ti ti-file-type-pdf me-1" />
                                          Export as PDF
                                        </div>
                                      </li> */}
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {loader ? (
              <div className="card-body p-0">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    height: "30vh",
                    alignItems: "center",
                  }}
                >
                  <Newloader />
                </div>
              </div>
            ) : (
              <div className="card-body p-0">
                {allEmployeeData && allEmployeeData.length > 0 && (
                  <Table
                    dataSource={allEmployeeData}
                    columns={columns}
                    Selection={true}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Coupon</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form
            // onSubmit={handleSubmit}
            >
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Discount Name{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Discount Code{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="coupon_code"
                            value={coupon_code}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Start Date <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="date"
                            name="start_date"
                            value={start_date}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            End Date <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="date"
                            name="end_date"
                            value={end_date}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {!percentage && (
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Discount Amount
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="number"
                              name="amount"
                              value={amount}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                      )}

                      {!amount && (
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Percentage
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="percentage"
                              value={percentage}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      // type="submit"
                      onClick={handleSubmit}
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="status_mo">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Change Status</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitStatus}>
              <div
                className="contact-grids-tab"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <h3>
                  Are you sure? you want to change the status to
                  {` ${newStatus?.status}`}
                </h3>
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default DiscountsList;
